import easyForm from "./easyForm/index.vue"
import easyTable from "./easyTable/index.vue"
import easyPagination from "./easyPagination/index.vue"

export const useGlobelComponents = (app) => {
    app.component('easyForm', easyForm)
    app.component('easyTable', easyTable)
    app.component('easyPagination', easyPagination)
}


// WEBPACK FOOTER //
// ./src/components/globelComponents.js